/** Packages — create view (delegates to the shared PackageForm). */
import { PackageForm } from "./_PackageForm";

export function PackageCreate() {
  return <PackageForm action="create" />;
}

export default PackageCreate;
